import Axios from 'axios';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { useRef } from 'react';
import { systemCode, xs_languageCode } from '../..';
import Loader from '../../common/Loader';
import PrematchHomeContext from '../../contexts/PrematchHomeContext';
import { dataFetchReducer } from '../../data/data';
import { parseTournamentData } from '../../data/parseTournamentData';
import { filterBetsByNumberOfOdds, filtraParametriche, getConfiguration, getPrincipaleOPrimoGruppo } from '../../data/utils';
import { CustomCols } from '../../live/Live';
import PrematchTournamentDay from './PrematchTournamentDay';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import LiveContext from '../../contexts/LiveContext';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import MainContext from '../../contexts/MainContext';

function PrematchTournamentLiveMatches(props) {
    const conf = getConfiguration();
    const customCols = React.useContext(CustomCols);
    const ctxs = useRef({}).current;
    const prematchHomeContext = React.useContext(PrematchHomeContext);
    const mainContext = useContext(MainContext);
    const liveContext = useContext(LiveContext);
    const seoContext = React.useContext(SeoContext);
    ctxs.betslipContext =  React.useContext(BetslipContext);
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    const [showLoader,setShowLoader] = useState(true);
    const handledOpenFromPath = useRef(false);
    
    const [tournament, setTournament] = useState(props.tournament);
    const aggregate = props.tournament.liveData.aggregate;
    const primaAggregata = getPrincipaleOPrimoGruppo(aggregate).idAggregata;
    const [aggregata, setAggregata] = useState(primaAggregata);
    const [aggregataFetch] = useState(primaAggregata);

    const [bets,setBets] = useState([]);

    function openLiveMatch(sport, country, tournament, pal, avv, path) {
        liveContext.setMatchDataPalAvv({
            sportId: sport,
            countryId: country,
            tournamentId: tournament,
            pal: pal,
            avv: avv
        });
        let callback;
        if(conf.seoplesu){
            const locationPathname = new String( window.location.pathname);
            callback = () =>{
                setTimeout(() => {
                    window.history.replaceState(window.history.state, null, locationPathname);
                    seoContext.refreshPathname(path, mainContext.currentSection.current);
                }, 5)
            } 
        }
        window.openSection('live-match',callback);
    }

    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getTorneoCentraleLive;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            sportId: props.tournament.sportRef,
            categoryId: props.tournament.categoryRef,
            tournamentId: props.tournament.id,
            idAggregata: aggregataFetch
        }
        fetchData(url, params, function(response) {
            try {
                const updatedData = parseTournamentData(props.data, response, props.tournament.uniqueId, params.idAggregata, true);
                if (updatedData.events && updatedData.events.length > 0) {
                	setTournament(updatedData);
                } else {
                	setTournament(null);
                }
            } catch (e) {
                console.error(e);
                setTournament(null);
            }
            setAggregata(aggregataFetch);
            dispatch({ type: 'FETCH_SUCCESS' });
        });

        const intervalMillis = getConfiguration()?.lpo ?? 10000;
        const interval = setInterval(() => {
            if(!ctxs?.betslipContext?.betInProgress) {
                setShowLoader(false);
                fetchData(url, params, function(response) {
                    try {
                        const updatedData = parseTournamentData(props.data, response, props.tournament.uniqueId, params.idAggregata, true);
                        if (updatedData.events && updatedData.events.length > 0) {
                            setTournament(updatedData);                    	
                        } else {
                            setTournament(null);
                        }
                    } catch (e) {
                        console.error(e);
                        setTournament(null);
                    }
                    setAggregata(aggregataFetch);
                    dispatch({ type: 'FETCH_SUCCESS' });        
                });
            }
        }, intervalMillis);
        
        return () => {
            didCancel = true;
            clearInterval(interval);
            //setShowLoader(true);
        };
    }, [props.data, props.tournament, aggregataFetch]);

    useEffect(function() {
        if (tournament) {
            if (tournament.events.length === 0) {
                return;
            }
            // Se non è stato aperto un evento specifico da autocomplete
            if (prematchHomeContext.match == null) {
                if (props.openFromPath && !handledOpenFromPath.current && props.openFromPath.match) {// Se la URL path contiene le info per aprire il match
                    
                    const evento = tournament.events.find(function(e){return e.pal==props.openFromPath.match.pal && e.avv==props.openFromPath.match.avv});
                    if (evento != null) {
                        if(conf.seoplesu && evento.isLive){
                            openLiveMatch(evento.sportRef,evento.categoryRef,evento.tournamentRef,evento.pal, evento.avv, evento.urlPath);
                        }else{
                            prematchHomeContext.changeMatch(evento);
                        }
                        handledOpenFromPath.current = true;
                    }
                } else { // apro il primo match del torneo corrente
                    prematchHomeContext.changeMatch(tournament.events[0], true);
                }
            }
    
            let tBets = [];
            tBets = tournament.events[0].bets;
            setBets(tBets);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tournament]);

    if ((showLoader && state.isLoading) || state.isError) {
        return <Loader error={state.isError} />;
    }

    const headerBets = filterBetsByNumberOfOdds(filtraParametriche(bets), customCols);
    const filteredBets = filterBetsByNumberOfOdds(bets, customCols);

    return (
        <>
            {tournament != null ?
                <div className="contenitore-table-grande margine-su-mezzo">
                    <div className="contenitore-table bg-bianco collapse show bordo-tondo" id="tabella-d">
                        {tournament.dates.map((date, dateIndex) =>
                            <PrematchTournamentDay key={dateIndex} id={dateIndex} date={date} tournament={tournament} matches={tournament.matchesByDate[date]} bets={filteredBets} headerBets={headerBets} aggregata={aggregata} isLive={true} />
                        )}
                    </div>
                </div>
                :
                <></>
            }
        </>
    );
}

export default PrematchTournamentLiveMatches;